import { SummaryHeader } from '../../../../components';
import { useFormContext } from 'react-hook-form';
import { useContext } from 'react';
import { Localization } from '../../../../config/localization/localization';
import { LanguageSelectorContext } from '../../../../context/LanguageSelectorContext';

import type { IFile } from '../../../../types';
import type { FC } from 'react';

interface IPhotosAndDocumentsProps {
    setStep: (step: number) => void;
}

export const PhotosAndDocumentsSummary: FC<IPhotosAndDocumentsProps> = ({ setStep }) => {
    const formContext = useFormContext();
    const { selectedLanguage } = useContext(LanguageSelectorContext);
    const localization = new Localization(selectedLanguage);

    const files: Array<IFile> = formContext.getValues('files') ?? [];

    const onStepClick = () => setStep(1);

    return (
        <div className={'flex w-full flex-col'}>
            {/* STEP LINK */}
            <SummaryHeader isLink onLink={onStepClick}>
                {localization.translate('photosAndDocumentsSummary.stepLink')}
            </SummaryHeader>

            {/* NO FILES MESSAGE */}
            {files?.length === 0 && (
                <span className={'font-medium dark:text-gray-200'}>
                    {localization.translate('photosAndDocumentsSummary.noFilesMessage')}
                </span>
            )}

            {/* FILES */}
            <div className={'flex flex-col'}>
                {files?.map((f) => (
                    <div className={'mt-0.5'} key={f.id}>
                        <span className={'font-bold'}>{f.displayName}</span>
                        {f.note && <span> - {f.note}</span>}
                    </div>
                ))}
            </div>
        </div>
    );
};